export const CellLoadingIndictor = () => {
  return (
    <div className="animate-pulse flex-grow h-full flex items-center">
      <div className="ml-2 h-2 w-2/5 bg-gray-2"></div>
    </div>
  );
};
